import type { DocumentType } from '../model.ts';

const DOCUMENT_TYPE_LABEL: Record<DocumentType, string> = {
  VEHICLE_REGISTRATION: '行車執照',
  DRIVING_LICENSE: '駕駛執照',
  INSURANCE_POLICY: '車險保單',
};

const DOCUMENT_TYPE_OPTIONS = (
  Object.keys(DOCUMENT_TYPE_LABEL) as DocumentType[]
).map((value) => ({ value, label: DOCUMENT_TYPE_LABEL[value] }));

export { DOCUMENT_TYPE_LABEL, DOCUMENT_TYPE_OPTIONS };
